import styled from 'styled-components';
import { Button, Row } from 'antd';
import BaseSearchInput from 'global/Input/SearchInput';
import { EditProfileCard } from '../styled';

interface TextProps {
  size?: string;
  lineHeight?: string;
  weight?: number | 'normal' | 'bold';
  marginBottom?: string;
  color?: string;
  align?: 'left' | 'center' | 'right';
}

export const Text = styled.p<TextProps>`
  font-size: ${({ size = '14px' }) => `${size}`};
  font-weight: ${({ weight = 'normal' }) => weight};
  line-height: ${({ lineHeight = '19px' }) => `${lineHeight}`};
  margin-bottom: ${({ marginBottom = '0px' }) => `${marginBottom}`};
  color: ${({ color = '#333333' }) => color};
  text-align: ${({ align }) => align};
`;

export const Card = styled(EditProfileCard)`
  & > .ant-card-body {
    padding: 0;
  }
`;

export const Divider = styled.div`
  height: 8px;
  width: 100%;
  background-color: #f7f7f7;
`;

export const HeaderRow = styled(Row)`
  padding: 20px;
`;

export const RowHeaderContainer = styled.div`
  padding: 0 20px;
  width: 100%;
`;

export const RowContentWrapper = styled(Row)`
  padding: 20px 0 0;
`;

export const SearchInput = styled(BaseSearchInput)`
  margin-bottom: 20px;
`;

export const SaveWrapper = styled(Row)`
  padding: 20px;
`;

export const SaveButton = styled(Button)`
  height: unset;
  border-radius: 4px;
  padding: 12px 20px;

  font-size: 14px;
  font-weight: 700;
  line-height: 19px;

  margin: 0 !important;
`;

export const ErrorWrapper = styled(Row)`
  background: #ffffff;
  border: 1px solid #dadada;
  border-radius: 2px;
  width: 100%;
  height: 515px;

  & > .ant-col > .ant-row {
    min-height: 451px;
    padding: 24px 0;
  }
`;

export const UserListWrapper = styled(Row)`
  min-height: 392px;

  .user-list {
    padding: 0 20px;
  }
`;

export const UserListErrorWrapper = styled(Row)`
  height: 100%;
`;

export const EmptyUserListWrapper = styled(Row)`
  min-height: 364px;
`;
